import { render, staticRenderFns } from "./ChannelList.view.vue?vue&type=template&id=786550f0&"
import script from "./ChannelList.view.vue?vue&type=script&lang=js&"
export * from "./ChannelList.view.vue?vue&type=script&lang=js&"
import style0 from "./ChannelList.view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports